/* ScheduleTypeComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Renderer = require("./ScheduleTypeRenderer");

class ScheduleTypeComponent extends DefaultColumnComponent {
    constructor(value) {
        super(value);
        this._value = value && value.schedule && value.schedule.type ? value.schedule.type : undefined;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /* *****************************************
    /* START PUBLIC API METHODS
    /* ***************************************** */
    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setScheduleType(newVal);
        }
    }

    getValue() {
        return this.getScheduleType();
    }

    setScheduleType(newVal) {
        this._value = newVal;
        this.emit("ScheduleType", newVal);
        return this;
    }

    getScheduleType() {
        return this._value;
    }

    /* *****************************************
    /* END PUBLIC API METHODS
    /* ***************************************** */
}

module.exports = ScheduleTypeComponent;
